import React from 'react';

const HeaderSection: React.FC<{ title: string }> = ({ title }) => (
    <div className="bg-gray-50 px-6 py-1 mb-4">
        <span className="font-medium rounded-t-lg heading-field tracking-wider">
            {title}
        </span>
    </div>
);

export default HeaderSection;
